import React from "react";

const STATUS_STYLES = {
  won:      { text: "Won",     bg: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  winning:  { text: "Winning", bg: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  on_track: { text: "On Track",bg: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
  lost:     { text: "Lost",    bg: "bg-red-500/15 text-red-300 border-red-500/30" },
  losing:   { text: "Losing",  bg: "bg-red-500/15 text-red-300 border-red-500/30" },
  off_track:{ text: "Off Track",bg:"bg-red-500/10 text-red-300 border-red-500/30" },
  pending:  { text: "Pending", bg: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  settled:  { text: "Settled", bg: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
  push:     { text: "Push",    bg: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
};

export default function StatusBadge({ status, testid, size = "sm" }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.pending;
  const sz = size === "lg" ? "text-xs px-3 py-1.5" : "text-[10px] px-2 py-1";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-md border font-bold uppercase tracking-wider ${s.bg} ${sz}`}
    >
      {(status === "winning" || status === "losing" || status === "on_track" || status === "off_track" || status === "pending") && (
        <span className={`h-1.5 w-1.5 rounded-full animate-pulse ${status.includes("track") || status === "winning" ? "bg-emerald-400" : status === "pending" ? "bg-amber-400" : "bg-red-400"}`} />
      )}
      {s.text}
    </span>
  );
}
